import { forwardRef, type Ref, type SVGProps } from "react";
const IconSendFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="m29.971 4.565-7.74 24.09a1.98 1.98 0 0 1-1.69 1.37 2 2 0 0 1-.23.02 1.98 1.98 0 0 1-1.72-1l-5.21-8.94 1.46-1.46 5.45-5.46a1 1 0 0 0-1.41-1.41l-6.86 6.86-9.19-6.12a2 2 0 0 1 .56-3.59l24.12-6.89a1.99 1.99 0 0 1 1.99.53 2.02 2.02 0 0 1 .47 2" />
  </svg>
);
const ForwardRef = forwardRef(IconSendFilledSVG);
ForwardRef.displayName = "IconSendFilled";
export { ForwardRef as IconSendFilled };
